import { useGetUsersQuery } from 'api/UsersEndPoints';
import TopUserConnection from 'modules/Dashboard/TopUser';
import { useMemo } from 'react';
import Loader from 'shared/component/Loader';
import { Statistics } from 'shared/model/statistic.model';
import Metric from 'shared/routes/components/Metric/Metric';

type Props = {
  stats: Statistics;
};

const TopUsersMetric = ({ stats }: Props) => {
  const connections = stats.usersConnections.slice(0, 5);

  const userIds = connections.map(c => c.userId);

  const { data, isLoading } = useGetUsersQuery({
    fields: ['id', 'email', 'firstName', 'lastName'],
    where: {
      id: {
        inq: userIds,
      },
    },
  });

  const users = data ?? [];

  const tops = useMemo(() => {
    if (!stats) return [];
    return stats.usersConnections.map(connection => {
      const result = {
        ...connection,
      } as any;
      const found = users.find(u => u.id === connection.userId);
      if (found) {
        result.name = found.firstName + ' ' + found.lastName;
      }
      return result;
    });
  }, [users, stats]);

  return (
    <Metric label="Top 5 Users">
      {isLoading ? (
        <Loader />
      ) : (
        <div>
          {tops.map(item => (
            <TopUserConnection key={item.userId} item={item} name={item.name} />
          ))}
        </div>
      )}
    </Metric>
  );
};

export default TopUsersMetric;
